import React from 'react';
// eslint-disable-next-line
import IconDecreaseSvg from '!svg-react-loader!./assets/icon-decrease.svg';
// eslint-disable-next-line
import IconIncreaseSvg from '!svg-react-loader!./assets/icon-increase.svg';
// eslint-disable-next-line
import IconNoChangeSvg from '!svg-react-loader!./assets/icon-noChange.svg';
import colors from 'src/utils/colors';

// eslint-disable-next-line
import IconRightArrowSvg from '!svg-react-loader!./assets/icon-rightArrow.svg';
// eslint-disable-next-line
import IconReloadingSvg from '!svg-react-loader!./assets/icon-reloading.svg';

/**
 * Inside of the row, the icon is positioned
 * at the bottom of the div so this moves it up
 */
const iconStyle: React.CSSProperties = {
  position: 'relative',
  top: '-3px'
};

const IconIncrease = <IconIncreaseSvg style={{ ...iconStyle, color: colors.brandClubGreen }} />;
const IconNoChange = (
  <IconNoChangeSvg
    style={{
      ...iconStyle,
      // Rotate 90 deg
      transform: 'rotate(90deg)'
    }}
  />
);
const IconDecrease = <IconDecreaseSvg style={{ ...iconStyle, color: colors.errorRed }} />;
interface IconProps {
  transform?: string;
  color?: string;
}

export const CustomIconIncrease: React.FC<IconProps> = ({ color = colors.brandClubGreen, ...props }) => (
  <IconIncreaseSvg style={{ ...iconStyle, color, ...(props.transform ? { transform: props.transform } : {}) }} />
);

export const CustomIconDecrease: React.FC<IconProps> = ({ color = colors.errorRed, ...props }) => (
  <IconDecreaseSvg style={{ ...iconStyle, color, ...(props.transform ? { transform: props.transform } : {}) }} />
);

const IconReloading = <IconReloadingSvg style={{ width: 16, height: 16 }} />;
const IconReloadingDisabled = <IconReloadingSvg style={{ width: 16, height: 16, opacity: 0.3, marginLeft: '-8px' }} />;

/**
 * RightArrow Icon that is used in topEntityChartV2 in product view XAxis hover status
 */
const IconRightArrow = <IconRightArrowSvg style={{ display: 'inline-block', width: '12px', marginLeft: '4px' }} />;

export { IconIncrease, IconDecrease, IconNoChange, IconRightArrow, IconReloading, IconReloadingDisabled };
